import { createFileRoute } from "@tanstack/react-router";
import { parseRunId } from "@/components/agents/config-prefill";
import { WorkspaceAutomationRoute } from "@/components/automations/workspace-automation-route";
import { OwnerWorkspaceGate } from "@/components/owner-workspace-gate";
import { useWorkspaceRoot } from "@/lib/api";

function parseView(value: unknown): "activity" | "definition" {
	return value === "definition" ? "definition" : "activity";
}

/**
 * Workspace-level Automation detail: the single home for every automation,
 * agent-owned and agentless alike. It opens on its results (what the Home peek
 * shows, full width); `?view=definition` opens the edit form, `?run_id=` opens
 * the held builder proposal review (agent-owned automations).
 */
export const Route = createFileRoute("/$owner/automations/$automationId")({
	loader: ({ context: { queryClient }, params }) => {
		void queryClient.prefetchQuery(
			useWorkspaceRoot.queryOptions(params.owner, { slug: params.owner }),
		);
	},
	validateSearch: (search: Record<string, unknown>) => ({
		run_id: parseRunId(search.run_id),
		view: parseView(search.view),
	}),
	component: WorkspaceAutomationPage,
});

function WorkspaceAutomationPage() {
	const { owner, automationId } = Route.useParams();
	const search = Route.useSearch();
	return (
		<OwnerWorkspaceGate owner={owner}>
			{() => (
				<WorkspaceAutomationRoute
					owner={owner}
					automationId={automationId}
					view={search.view}
					runId={search.run_id}
				/>
			)}
		</OwnerWorkspaceGate>
	);
}
